import FranchiseModal from './FranchiseModal';
import DomainTab from './DomainTab';

export default {
  FranchiseModal,
  DomainTab,
};
